// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ds-btn{height:40px;border-radius:4px;font-size:1em;color:#09f;padding:0 8px}.ds-btn.selected{background:#09f;color:#fff}.ds-btn.selected:hover{background-color:#66c2ff}.ds-btn:hover{background-color:#f6f6f6}", ""]);
// Exports
module.exports = exports;
